import { DialogService, GridAction } from '@eforall/dashboard';
import { AcceleratorAreaService } from '../../../../accelerator-area.service';
import { AwardEditorDialog } from '../award-editor-dialog/award-editor.dialog';
import { Award } from '../awards-view.part';

export function getActions(dialogService: DialogService, accAreaService: AcceleratorAreaService) {

	const actions: GridAction<Award>[] = [
		{
			iconClass: 'fa-regular fa-pencil',
			label: 'Edit Award',
			isEnabled: rows => !!rows.length && accAreaService.canEdit(),
			execute: async rows => {

				await dialogService.showCustom(AwardEditorDialog, { data: { awardId: rows[0]?.awardId, eventId: rows[0]?.eventId } }, 600, 700);
				await accAreaService.reloadData(); // TODO: optimize to reload only if changes were made
			}
		},
		{
			iconClass: 'fa-regular fa-times',
			label: 'Delete Award',
			isEnabled: rows => !!rows.length && accAreaService.canEdit(),
			execute: async rows => {
				const awardId = rows[0]?.awardId;
				if (!awardId) return;

				const yes = await dialogService.confirm('Are you sure you want to delete the selected award?', 'Yes', 'No', [], 300, 200);
				if (yes) {
					await accAreaService.deleteAward(awardId);
				}
			}
		},
	];

	return actions;
}